// extracted by mini-css-extract-plugin
module.exports = {"text":"RotateSpring_text__1mCR5","container":"RotateSpring_container__346at"};